import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdClose, MdTraffic } from 'react-icons/md';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { useLanguage } from '../../context/LanguageContext';

export default function AddStatusSignalModal({ companyId, onClose, onSuccess }) {
    const { t } = useLanguage();
    const [name, setName] = useState('');
    const [state0Description, setState0Description] = useState('');
    const [state1Description, setState1Description] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !state0Description || !state1Description) {
            toast.error(t('addStatusSignalModal.fillAllFields'));
            return;
        }

        try {
            setLoading(true);
            await api.post('/status-signals', {
                companyId,
                name,
                state0Description,
                state1Description
            });
            toast.success(t('addStatusSignalModal.signalAdded'));
            onSuccess();
        } catch (error) {
            toast.error(error.response?.data?.message || t('addStatusSignalModal.signalAddFailed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            <motion.div className="modal-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                onClick={(e) => e.target === e.currentTarget && onClose()}>
                <motion.div className="modal" initial={{ opacity: 0, scale: 0.9, y: 30 }} animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.9 }} transition={{ duration: 0.3 }}>

                    <div className="modal-header">
                        <div className="modal-title">
                            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(59,130,246,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary)' }}>
                                <MdTraffic />
                            </div>
                            {t('addStatusSignalModal.title')}
                        </div>
                        <button type="button" className="modal-close" onClick={onClose}><MdClose /></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="form-group">
                                <label className="form-label">{t('addStatusSignalModal.signalName')}</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder={t('addStatusSignalModal.signalNamePlaceholder')}
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    autoFocus
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label" style={{ color: 'var(--danger)' }}>{t('addStatusSignalModal.state0')}</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder={t('addStatusSignalModal.state0Placeholder')}
                                    value={state0Description}
                                    onChange={(e) => setState0Description(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label" style={{ color: 'var(--success)' }}>{t('addStatusSignalModal.state1')}</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder={t('addStatusSignalModal.state1Placeholder')}
                                    value={state1Description}
                                    onChange={(e) => setState1Description(e.target.value)}
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>{t('common.cancel')}</button>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? <><span className="spinner spinner-sm" /> {t('common.adding')}</> : <><MdTraffic /> {t('addStatusSignalModal.addSignal')}</>}
                            </button>
                        </div>
                    </form>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
}
